import React, { Component } from "react";
import Box from "../ui/Box";
import Select from "react-select";
import { RaisedButton, FlatButton } from "material-ui";
import Dialog from 'material-ui/Dialog';
import { Table, TableBody, TableHeader, TableHeaderColumn, TableRow, TableRowColumn, TableFooter } from 'material-ui/Table';

//providers
import DataService from '../../services/DataService';
var ds = DataService;

var LOCK_EVENTS = [
    {
        label: "On Unlock Event",
        value: "unlock"
    },
    {
        label: "On Lock Event",
        value: "lock"
    }
];

var ALL_EVENTS_REV = {
    "unlock": "On Unlock Event",
    "lock": "On Lock Event"
};

export default class PostEventActions extends Component {
    constructor(props) {
        super(props);
        this.state = {
            all_actions: [],
            all_devices: [],
            all_switches: [],
            possible_events: [],
            selected_event: "",
            selected_switch_appliance: "",
            selected_switch_action: "",
            actions_id: "",
            switch_name_dict: {},
            dialog: {
                open: false,
                head: 'Dude',
                body: 'This is working',
                actions: [
                    <FlatButton
                        label="Okay"
                        primary
                        onClick={this.closeDialog.bind(this)}
                    />
                ]
            }
        }
    }

    componentDidMount() {
        this.getPostActions();
        this.getAllDevices();
    }

    getPostActions() {
        ds.postGetPostEventActions({
            intent: "list",
            ud_id: this.props.ud_id
        }, data => {
            if (data && data[0]) {
                this.setState({
                    all_actions: data[0].actions,
                    actions_id: data[0]._id
                })
            }
        }, err => {

        })
    }

    getAllDevices() {
        ds.getSwitchesInRoom(this.props.room_id, data => {
            let switch_name_dict = {};
            if (data && data.switchAppliances && data.switchAppliances.length) {
                for (let i of data.switchAppliances) {
                    switch_name_dict[i._id] = i.name;
                }
            }
            this.setState({
                all_switches: data && data.switchAppliances ? data.switchAppliances.map(x => { return { ...x, label: x.name, value: x._id } }) : [],
                switch_name_dict
            });

        }, err => { });

        ds.getDevicesInRoom(this.props.room_id, data => {
            this.setState({
                all_devices: data,
                possible_events: []
            }, () => {
                this.setEventsList();
            })
        }, err => { });
    }

    setEventsList() {
        for (let i of this.state.all_devices) {
            if (i._id == this.props.ud_id && (i.device_type_identifier == "SMART_LOCK" || i.device_type_identifier == "KIOT_LOCK")) {
                this.setState({
                    possible_events: LOCK_EVENTS
                })
                return;
            }
        }
    }

    createAction(e) {
        e.preventDefault();
        let payload;
        if (this.state.actions_id) {
            payload = {
                intent: "update",
                actions: [...this.state.all_actions, this.getNewAction()],
                actions_id: this.state.actions_id,
                ud_id: this.props.ud_id
            }
        }
        else {
            payload = {
                intent: "add",
                actions: [this.getNewAction()],
                ud_id: this.props.ud_id
            }
        }
        ds.postAddPostEventActions(payload, data => {
            this.setState({
                selected_event: "",
                selected_switch_appliance: "",
                selected_switch_action: ""
            });
            this.getPostActions();
        }, err => {

        })
    }

    deleteAction(row_id) {

        this.setState({
            dialog: {
                open: true,
                head: 'Delete',
                body: 'Delete Action permanently?',
                actions: [
                    <FlatButton
                        label="Delete"
                        primary
                        onClick={() => {
                            let all_actions = [];
                            for (let i of this.state.all_actions) {
                                if (i._id != row_id) {
                                    all_actions.push(i);
                                }
                            }
                            let payload = {
                                intent: "update",
                                actions: all_actions,
                                actions_id: this.state.actions_id,
                                ud_id: this.props.ud_id
                            };
                            this.closeDialog();
                            ds.postAddPostEventActions(payload, data => {
                                this.setState({
                                    all_actions
                                });
                            }, err => {

                            })
                        }}
                    />,
                    <FlatButton
                        label="Cancel"
                        primary
                        onClick={this.closeDialog.bind(this)}
                    />
                ]
            }
        });
    }

    getNewAction() {
        let ud_id, kd_id, switch_no;
        for (let i of this.state.all_switches) {
            if (i._id == this.state.selected_switch_appliance) {
                ud_id = i.UDid;
                kd_id = i.device_id
                switch_no = i.switch_no;
            }
        }
        return {
            event: this.state.selected_event,
            action: {
                ud_id,
                kd_id,
                actionType: "switch",
                switch_state: this.state.selected_switch_action,
                switch_no,
                switch_appliance_id: this.state.selected_switch_appliance
            }
        }
    }


    closeDialog() {
        this.setState({
            dialog: {
                head: '',
                body: '',
                open: false,
                actions: []
            }
        })
    }

    render() {
        return (<div className="row">
            <div className="col-sm-4">
                <Box header='Create Action After Event'>
                    <Dialog
                        title={this.state.dialog.head}
                        actions={this.state.dialog.actions}
                        modal={false}
                        open={this.state.dialog.open}
                        onRequestClose={this.closeDialog.bind(this)}
                    >
                        {this.state.dialog.body || 'NA'}
                    </Dialog>
                    <form className="smart-form " onSubmit={this.createAction.bind(this)}>
                        <fieldset>

                            <section>
                                <Select
                                    id="events_list__p"
                                    ref={(ref) => { this.select = ref; }}
                                    onBlurResetsInput={false}
                                    onSelectResetsInput={false}
                                    autoFocus
                                    options={this.state.possible_events}
                                    simpleValue
                                    clearable={true}
                                    name="event_"
                                    disabled={false}
                                    value={this.state.selected_event}
                                    onChange={(newValue) => {
                                        this.setState({
                                            selected_event: newValue,
                                        })
                                    }}
                                    searchable={true}
                                    placeholder="Select Event"
                                    style={{ marginTop: "15px" }}
                                />
                            </section>

                            <section>
                                <Select
                                    id="slect_action_t__p"
                                    ref={(ref) => { this.select = ref; }}
                                    onBlurResetsInput={false}
                                    onSelectResetsInput={false}
                                    autoFocus
                                    options={[{
                                        label: "Turn On",
                                        value: true
                                    },
                                    {
                                        label: "Turn Off",
                                        value: false
                                    }]}
                                    simpleValue
                                    clearable={true}
                                    name="action__p"
                                    disabled={false}
                                    value={this.state.selected_switch_action}
                                    onChange={(newValue) => {
                                        this.setState({
                                            selected_switch_action: newValue,
                                        })
                                    }}
                                    searchable={true}
                                    placeholder="Select Action"
                                    style={{ marginTop: "15px" }}
                                />
                            </section>
                            <section>

                                <Select
                                    id="switches_list__p"
                                    ref={(ref) => { this.select = ref; }}
                                    onBlurResetsInput={false}
                                    onSelectResetsInput={false}
                                    autoFocus
                                    options={this.state.all_switches}
                                    simpleValue
                                    clearable={true}
                                    name="room_num"
                                    disabled={false}
                                    value={this.state.selected_switch_appliance}
                                    onChange={(newValue) => {
                                        this.setState({
                                            selected_switch_appliance: newValue,
                                        })
                                    }}
                                    searchable={true}
                                    placeholder="Select Switch"
                                    style={{ marginTop: "15px" }}
                                />
                            </section>


                        </fieldset>

                        <div className="mt-4vw align-right">
                            <RaisedButton
                                label="Save"
                                primary
                                type="submit"
                            />
                        </div>
                    </form>
                </Box>
            </div>
            <div className="col-sm-8">
                <Box header='Actions After Events List'>
                    <Table
                        height={'45vh'}
                        fixedHeader={true}
                        fixedFooter={true}
                        selectable={false}
                        multiSelectable={false}
                        bodyStyle={{ minWidth: 680, overflowX: 'auto' }}
                    >
                        <TableHeader displaySelectAll={false} adjustForCheckbox={false}>
                            <TableRow>
                                <TableHeaderColumn tooltip="On Event">Event</TableHeaderColumn>
                                <TableHeaderColumn tooltip="Action">Action</TableHeaderColumn>
                                <TableHeaderColumn tooltip="Appliance">Appliance Name</TableHeaderColumn>
                                <TableHeaderColumn tooltip="Options">Options</TableHeaderColumn>
                            </TableRow>
                        </TableHeader>

                        <TableBody
                            displayRowCheckbox={false}
                            showRowHover={true}
                            stripedRows={false}
                        >
                            {this.state.all_actions.map((row, index) => (
                                <TableRow key={index}>
                                    <TableRowColumn style={{ overflow: 'visible' }}>
                                        {ALL_EVENTS_REV[row.event]}
                                    </TableRowColumn>

                                    <TableRowColumn style={{ overflow: 'visible' }}>
                                        {row.action && row.action.actionType == "switch" ? row.action.switch_state ? "Turn On" : "Turn Off" : ""}
                                    </TableRowColumn>

                                    <TableRowColumn style={{ overflow: 'visible' }}>
                                        {row.action && row.action.switch_appliance_id ? this.state.switch_name_dict[row.action.switch_appliance_id] || "NA" : "NA"}
                                    </TableRowColumn>

                                    <TableHeaderColumn className="v-center">
                                        <i className="material-icons warn-fg"
                                            style={{ cursor: 'pointer' }}
                                            onClick={this.deleteAction.bind(this, row._id)}
                                        >delete</i>
                                    </TableHeaderColumn>
                                </TableRow>
                            ))}
                        </TableBody>

                        <TableFooter>

                        </TableFooter>
                    </Table>

                </Box>
            </div>
        </div>)
    }

}


// WEBPACK FOOTER //
// ./components/rooms/PostEventActions.js